(function(){
'use strict';

function DonationsCollectionFactory($http, scOrganizationsService) {
  /**
   * Putting that computer science degree to use.
   */
  function DonationsCollection(model, me, isTeam) {
    this.resource = isTeam ? 'fundraising-teams' : 'fundraising-pages';

    this.me = me;
    this.dateOrder = 'desc';
    this.unacknowledgedQueue = [];
    this.model = model;
    this.page = 0;
    this.pastPage = 0;
    this.baseUrl = '/frs-api/' + this.resource + '/' + this.model.id;
    this.hasPastDonorsAccess = !!scOrganizationsService.getTag('early-access:list-past-donnors', true);

    this.DEFAULT_PER_PAGE = 10;
    this.MAX_PER_PAGE = 100;
    this.TIMEOUT_MS = 10000;
  }

  // Current donors
  DonationsCollection.prototype.get = function tempGet(sorter) {
    var _this = this;

    this.page += 1;
    this.dateOrder = sorter;

    var params = {
      page: this.page,
      filter: 'linkable_type*=donation',
      with: 'linkable',
      sort: 'created_at:' + this.dateOrder,
      per_page: this.DEFAULT_PER_PAGE,
      member_id: this.me.id
    };

    return $http({
      url: this.baseUrl + '/feed-item-donations',
      params: params,
      method: 'GET',
      timeout: this.TIMEOUT_MS
    }).catch(function (error) {
      // Reset page on error to prevent getting stuck
      _this.page = Math.max(0, _this.page - 1);
      throw error;
    });
  };

  DonationsCollection.prototype.resetPage = function pageReset() {
    this.page = 0;
  };

  // Past donors
  DonationsCollection.prototype.getPastDonors = function getPastDonorsMethod() {
    var _this2 = this;

    var perPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    this.pastPage += 1;

    // Past donors are not supported for teams yet
    if (this.resource !== 'fundraising-pages' || !this.hasPastDonorsAccess) {
      return Promise.resolve({ data: { data: [], total: 0 } });
    }

    var validPerPage = Math.min(Math.max(parseInt(perPage, 10) || 5, 1), this.MAX_PER_PAGE);

    var params = {
      page: this.pastPage,
      per_page: validPerPage,
      hideAlreadyDonated: !!opts.hideAlreadyDonated,
      sortReverse: !!opts.sortReverse
    };

    return $http({
      url: this.baseUrl + '/past-donors',
      params: params,
      method: 'GET',
      timeout: this.TIMEOUT_MS
    }).catch(function (error) {
      _this2.pastPage = Math.max(0, _this2.pastPage - 1);
      throw error;
    });
  };

  DonationsCollection.prototype.resetPastPage = function resetPastPageMethod() {
    this.pastPage = 0;
  };

  return DonationsCollection;
}

angular.module('classy.frs').factory('DonationsCollection', ['$http', 'scOrganizationsService', DonationsCollectionFactory]);
})();